// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const PrivacyPolicyPage = () => {
  return <LegalPageContent slug="privacy-policy" fallbackTitle="Privacy Policy" />;
};
